
document.addEventListener("DOMContentLoaded", function () {
    const menuItems = document.querySelectorAll(".points-moxie-aside-list ul li");
    const tabs = document.querySelectorAll(".points-moxie-content .tab");

    menuItems.forEach(item => {
        item.addEventListener("click", function () {
            // Remover la clase 'active' del li previamente activo
            document.querySelector(".points-moxie-aside-list ul li.active")?.classList.remove("active");

            // Agregar la clase 'active' al li clickeado
            this.classList.add("active");

            // Obtener el data-tab del li clickeado
            const selectedTab = this.getAttribute("data-tab");

            // Remover la clase 'active' de la pestaña previamente activa y añadir 'inactive'
            document.querySelector(".points-moxie-content .tab.active")?.classList.replace("active", "inactive");

            // Encontrar la pestaña correspondiente y cambiar 'inactive' por 'active'
            const tabToShow = document.querySelector(`.points-moxie-content .tab[data-position="${selectedTab}"]`);
            if (tabToShow) {
                tabToShow.classList.replace("inactive", "active");
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const tabSelectors = document.querySelectorAll(".tab-selector div");
    const tabs = document.querySelectorAll(".fp-container-puntos [data-puntos-position]");

    tabSelectors.forEach(tab => {
        tab.addEventListener("click", function () {
            // Remover la clase 'active' del tab previamente activo
            document.querySelector(".tab-selector div.active")?.classList.remove("active");

            // Agregar la clase 'active' al tab clickeado
            this.classList.add("active");

            // Obtener el data-puntos-tab del tab clickeado
            const selectedTab = this.getAttribute("data-puntos-tab");

            // Remover la clase 'puntos-tab-active' del contenido previamente activo y añadir 'puntos-tab-inactive'
            document.querySelector(".fp-container-puntos .puntos-tab-active")?.classList.replace("puntos-tab-active", "puntos-tab-inactive");

            // Encontrar la pestaña correspondiente y cambiar 'puntos-tab-inactive' por 'puntos-tab-active'
            const tabToShow = document.querySelector(`.fp-container-puntos [data-puntos-position="${selectedTab}"]`);
            if (tabToShow) {
                tabToShow.classList.replace("puntos-tab-inactive", "puntos-tab-active");
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", () => {
    let detalleCliente = {};
    let categorias = [];
    let historial = [];


  
    async function obtenerDetalleCliente(client) {

        try {
            let response = await fetch("https://festipuntosb.sempertex.com/users/", {
                method: "GET",
                headers: {
                    'Authorization': `Bearer 10008882`,
                    'Content-Type': 'application/json'
                }
            });
            
            if (!response.ok) throw new Error("Error en la respuesta");

            let detalleCliente = await response.json();
            console.log("detalleCliente:", detalleCliente);
          
            pintarDatosCliente(detalleCliente);
            renderizarCategorias(detalleCliente.data.CategoriasActivadas);

          
        } catch (error) {
            console.error("Error obteniendo detalle cliente:", error);
        }
    }

    async function obtenerCategorias(client) {
        try {
            let response = await fetch("https://festipuntosb.sempertex.com/users/getCategories", {
                method: "GET",
                headers: {
                    'Authorization': `Bearer 10008882`,
                    'Content-Type': 'application/json'
                }
            });
            
            if (!response.ok) throw new Error("Error en la respuesta");
            
            let categorias = await response.json();
            console.log("Categorías:", categorias);
        } catch (error) {
            console.error("Error obteniendo categorías:", error);
        }
    }
  
    function obtenerDatosLanding() {
        fetch("https://festipuntosb.sempertex.com/landing/")
            .then(response => {
                if (!response.ok) {
                    throw new Error("Error en la respuesta");
                }
                return response.json();
            })
            .then(data => {
                renderizarInformacion(data.data);
            })
            .catch(error => {
                console.error("Error obteniendo datos de landing:", error);
            });
    }

  
    
    // Llamamos a las funciones para obtener los datos

    
      console.log('aqui toy', )
    obtenerDatosLanding();
    obtenerDetalleCliente();
    obtenerCategorias();

});

function renderizarInformacion(data) {
    // Renderizar data.pasos
    document.getElementById("quees").innerHTML = `
        <h1>${data.Pasos.QueEs.Titulo}</h1>
        <p>${data.Pasos.QueEs.Descripcion}</p>
    `;
    
    document.getElementById("registrate").innerHTML = `
        <h2>${data.Pasos.Registrate.Titulo}</h2>
        <p>${data.Pasos.Registrate.Descripcion}</p>
    `;

    document.getElementById("acumula").innerHTML = `
        <h2>${data.Pasos.Acumula.Titulo}</h2>
        <p>${data.Pasos.Acumula.Descripcion}</p>
    `;
    
    document.getElementById("vencimiento").innerHTML = `
        <h3>${data.Pasos.Vencimiento.Titulo}</h3>
        <p>${data.Pasos.Vencimiento.Descripcion}</p>
    `;
    
    document.getElementById("consulta").innerHTML = `
        <h1>${data.Pasos.Consulta.Titulo}</h1>
        <p>${data.Pasos.Consulta.Descripcion}</p>
    `;

    // Renderizar data.categoria
    data.Categoria.forEach(categoria => {
        const categoriaElement = document.createElement('div');
        categoriaElement.classList.add('comparacion-group', 'group-' + categoria.NombreCategoria.toLowerCase().replace(/\s+/g, '-'));
        categoriaElement.style.backgroundColor = `${categoria.ColorFondo}`
        categoriaElement.innerHTML = `
            <div class="contenedorimagen-beneficios">
                <img src="${categoria.Imagen}" alt="">
            </div>
            <h1>${categoria.Titulo}</h1>
            <p>
                ${categoria.Beneficios.map(beneficio => `- ${beneficio}`).join('<br>')}
            </p>
        `;
        document.querySelector('.container_comparacion').appendChild(categoriaElement);
    });

    // Renderizar cliente actual
    document.getElementById("cliente-actual-titulo").innerText = data.ClienteActual.Titulo;
    document.getElementById("cliente-actual-subtitulo").innerHTML = `<strong>${data.ClienteActual.Subtitulo}</strong>`;
    document.getElementById("cliente-actual-descripcion").innerText = data.ClienteActual.Descripcion;
    document.getElementById("cabecera-titulo").innerText = data.Cabecera.Titulo;
    document.getElementById("cabecera-subtitulo").innerText = data.Cabecera.Subtitulo;
    document.getElementById("misfestipuntos-descripcion").innerText = data.MisFestipuntos.Descripcion;

  
    // Renderizar beneficios del cliente Oro (data.beneficios)
    const beneficiosOro = data.Beneficios.find(beneficio => beneficio.NombeBeneficio === "Oro");
    if (beneficiosOro) {
        const containerBeneficios = document.querySelector('.fp-container-puntos-beneficios .container_beneficios');
        beneficiosOro.Detalles.forEach((detalle, index) => {
            const beneficioElement = document.createElement('div');
            beneficioElement.classList.add('beneficios-group');
            beneficioElement.innerHTML = `
                <div class="contenedorimagen">
                    <img src="${detalle.Imagen}" alt="Beneficio ${index + 1}">
                </div>
                <h1 id="tus-beneficios-titulo-${index + 1}">${detalle.Titulo}</h1>
                <p id="tus-beneficios-des-${index + 1}">${detalle.Descripcion}</p>
            `;
            containerBeneficios.appendChild(beneficioElement);
        });
    }
}



function pintarDatosCliente(data) {
    if (!data || data.status !== "success") {
        console.error("Datos de cliente no válidos");
        return;
    }

    const cliente = data.data;
    console.log('Clientesote', cliente);
    
    // Puntos
    document.getElementById("puntosDisponibles").textContent = cliente.puntos.Puntos_disponibles;
    document.getElementById("puntosTransicion").textContent = cliente.puntos.Puntos_en_transicion;
    document.getElementById("puntosVencer").textContent = cliente.puntos.Puntos_por_vencer;
  
    document.getElementById("main-puntosdisponibles").textContent = cliente.puntos.Puntos_disponibles;
    
    if(cliente.PorcentajeCategoriaActivas != "-1") document.getElementById("barra-progreso").classList.add(`barra-progreso-${cliente.PorcentajeCategoriaActivas}`);
    if(cliente.PorcentajeCompra != "-1") document.getElementById("barra-progreso2").classList.add(`barra-progreso-${cliente.PorcentajeCompra}`);
    if(cliente.PorcentajeCategoriaActivas != "-1") document.getElementById("barra-progreso").textContent = `${cliente.PorcentajeCategoriaActivas}%`;
    if(cliente.PorcentajeCompra != "-1") document.getElementById("barra-progreso2").textContent = `${cliente.PorcentajeCompra}%`;

    // Actualizar montos de compra en las columnas
    const columnasCompra = document.querySelectorAll('.contenedor .columna:not(.first-column-mob) p');
    const categoriasCompra = categorias.data.filter(cat => cat.Codigo !== "001"); // Excluir Morado que tiene LimCompraMin = 0
    

        categoriasCompra.forEach((categoria, index) => {
            const valorMM = categoria.LimCompraMin / 1000000;
            columnasCompra[index].textContent = `${valorMM}MM`;
        });
    

    // Actualizar categorías activadas en las columnas
    const columnasCategoria = document.querySelectorAll('.contenedor2 .columna2:not(.first-column-mob) h2');
    const categoriasActivas = categorias.data.filter(cat => cat.Codigo !== "001"); // Excluir Morado que tiene LimCategoriaMin = 0
    
    if (columnasCategoria.length === categoriasActivas.length) {
        categoriasActivas.forEach((categoria, index) => {
            columnasCategoria[index].textContent = `${categoria.LimCategoriaMin}%`;
        });
    }

    // Puntos redimidos aun no disponible en la api
    // document.getElementById("main-puntosredimidos").textContent = cliente.puntos.Puntos_por_vencer;

    // Formatear fecha de vencimiento
    const fechaVencimiento = new Date(cliente.puntos.Fecha_de_vencimiento);
    document.getElementById("fechaVencimiento").textContent = fechaVencimiento.toLocaleDateString("es-ES");

    // Información personal
    document.getElementById("codigo-cliente").textContent = cliente.coduser;
    document.getElementById("nit-cc").textContent = cliente.nit;
    document.getElementById("nombre-compania").textContent = cliente.Nombre;
    document.getElementById("aside-name").textContent = cliente.NombreCon;
    document.getElementById("nombre-contacto").textContent = cliente.NombreCon;

    // Formatear fecha de cumpleaños
    const fechaCumple = new Date(cliente.FecCumple);
    document.getElementById("cumpleanos").textContent = fechaCumple.toLocaleDateString("es-ES");

    // Género
    document.getElementById("genero").textContent = cliente.Genero === "F" ? "Femenino" : "Masculino";

    // Contacto
    document.getElementById("email").textContent = cliente.Email;
    document.getElementById("telefono").textContent = cliente.Telefono;
}
/* OBTENER HISTORIAL */
document.addEventListener("DOMContentLoaded", () => {
    let historial = [];
    let currentPage = 1;
    const recordsPerPage = 25; // El límite de registros que nos da el servicio
    const tableBody = document.querySelector(".fp-container-historial tbody");
    const paginationContainer = document.createElement("div");
    paginationContainer.classList.add("pagination");
    document.querySelector(".fp-container-historial").appendChild(paginationContainer);
    const registrosInfo = document.querySelector(".fp-container-historial p");

    async function obtenerHistorial(client) {
        try {
            let response = await fetch(`https://festipuntosb.sempertex.com/users/history?page=${currentPage}&limit=${recordsPerPage}`, {
                method: "GET",
                headers: {
                    'Authorization': `Bearer 10008882`,
                    'Content-Type': 'application/json'
                }
            });
            
            if (!response.ok) throw new Error("Error en la respuesta");
            
            let data = await response.json();
            historial = data.data; // Datos del historial
            let totalRecords = data.paginationInfo.total; // Total de registros
            let totalPages = Math.ceil(totalRecords / recordsPerPage); // Total de páginas

            actualizarTabla();
            actualizarPaginacion(totalPages);
            actualizarInfoRegistros(data.paginationInfo.low, data.paginationInfo.high, totalRecords);


        } catch (error) {
            console.error("Error obteniendo historial:", error);
        }
    }

    function actualizarTabla() {
        tableBody.innerHTML = "";
        historial.forEach(registro => {
            let row = document.createElement("tr");

            let estado = registro.Estado ? "Completado" : "En Transición";
            let fecha = new Date(registro.FechaDcto).toLocaleDateString("es-ES");
            let redimidos = registro.Valor_Puntos ? registro.Valor_Puntos : 0;
            let facturaIcon = `
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#bd833d" class="bi bi-file-earmark-arrow-down" viewBox="0 0 18 18">
                    <path d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293z"/>
                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                </svg>`;

            row.innerHTML = `
                <td data-label="Membresía">${registro.TipoDcto}-${registro.NumDcto}</td>
                <td data-label="Fecha">${fecha}</td>
                <td data-label="Festipuntos">${registro.Puntos.toLocaleString()}</td>
                <td data-label="Redimidos">${redimidos.toLocaleString()}</td>
                <td data-label="Estado">${estado}</td>
                <td data-label="Factura">${facturaIcon} <button class="btn">Descargar</button></td>
            `;

            tableBody.appendChild(row);
        });
    }

    function actualizarPaginacion(totalPages) {
        paginationContainer.innerHTML = "";

        if (totalPages <= 1) return;

        let startPage = Math.max(currentPage - 2, 1); // Dos páginas anteriores a la actual
        let endPage = Math.min(currentPage + 2, totalPages); // Dos páginas posteriores a la actual

        let prevButton = document.createElement("button");
        prevButton.textContent = "«";
        prevButton.disabled = currentPage === 1;
        prevButton.addEventListener("click", () => cambiarPagina(currentPage - 1));
        paginationContainer.appendChild(prevButton);

        for (let i = startPage; i <= endPage; i++) {
            let pageButton = document.createElement("button");
            pageButton.textContent = i;
            if (i === currentPage) {
                pageButton.classList.add("active");
            }
            pageButton.addEventListener("click", () => cambiarPagina(i));
            paginationContainer.appendChild(pageButton);
        }

        let nextButton = document.createElement("button");
        nextButton.textContent = "»";
        nextButton.disabled = currentPage === totalPages;
        nextButton.addEventListener("click", () => cambiarPagina(currentPage + 1));
        paginationContainer.appendChild(nextButton);
    }

    function cambiarPagina(nuevaPagina) {
        currentPage = nuevaPagina;
        obtenerHistorial(  ); // Actualizar los datos de la página actual
    }

    function actualizarInfoRegistros(desde, hasta, total) {
        if (registrosInfo) {
            registrosInfo.textContent = `Mostrando Registros Del ${desde} Al ${hasta} De Un Total De ${total} Registros.`;
        }
    }

    
    obtenerHistorial(  );
});

function renderizarCategorias(categorias) {
    const maxFilasPorTabla = 15;
    const container = document.querySelector(".fp-container-puntos-tables .container"); // El contenedor donde agregar las tablas

    // Dividir las categorías en grupos de 15 para crear tablas
    const categoriasDivididas = [];
    for (let i = 0; i < categorias.length; i += maxFilasPorTabla) {
        categoriasDivididas.push(categorias.slice(i, i + maxFilasPorTabla));
    }

    // Crear las tablas dinámicamente
    categoriasDivididas.forEach((categoriasGrupo, index) => {
        const tabla = document.createElement("table");
        tabla.classList.add(`table${index + 1}`);
        
        // Crear encabezado de la tabla
        const thead = document.createElement("thead");
        thead.innerHTML = `
            <tr>
                <th>Categorias</th>
                <th>Activación</th>
                <th>Ver productos</th>
            </tr>
        `;
        tabla.appendChild(thead);

        // Crear el cuerpo de la tabla
        const tbody = document.createElement("tbody");

        // Agregar filas de categorías a la tabla
        categoriasGrupo.forEach(categoria => {
            const row = document.createElement("tr");

            // Crear celdas para cada fila
            const descripcion = categoria.Descripcion || "No disponible";
            const activacionIcon = categoria.Activadas
                ? `<img src="https://cdn.shopify.com/s/files/1/0593/1981/2289/files/chulo.png?v=1740587927" alt="Activada">`
                : `<img src="https://cdn.shopify.com/s/files/1/0593/1981/2289/files/equis.png?v=1740587927" alt="No Activada">`;
            row.innerHTML = `
                <td>${descripcion}</td>
                <td>${activacionIcon}</td>
                <td><button class="btn">Ver Productos</button></td>
            `;

            tbody.appendChild(row);
        });

        tabla.appendChild(tbody);
        container.appendChild(tabla); // Agregar la tabla al contenedor
    });
}


 




